export const COVER_WIDTH = 2400
export const COVER_HEIGHT = 1254

export const processCoverImage = (file: File): Promise<File> => {
	return new Promise((resolve, reject) => {
		const img = new Image()
		img.onload = () => {
			const targetWidth = COVER_WIDTH
			const targetHeight = COVER_HEIGHT
			const padding = 100

			// Create canvas
			const canvas = document.createElement("canvas")
			const ctx = canvas.getContext("2d")
			if (!ctx) {
				reject(new Error("Could not get canvas context"))
				return
			}

			canvas.width = targetWidth
			canvas.height = targetHeight

			ctx.fillStyle = "#F4F4F4"
			ctx.fillRect(0, 0, targetWidth, targetHeight)

			// Calculate image dimensions to fit within padding
			const imageWidth = targetWidth - padding * 2
			const imageHeight = targetHeight - padding * 2

			// Calculate scaling to maintain aspect ratio and fit within bounds
			const scaleX = imageWidth / img.width
			const scaleY = imageHeight / img.height
			const scale = Math.min(scaleX, scaleY)

			const scaledWidth = img.width * scale
			const scaledHeight = img.height * scale

			// Center the image
			const x = (targetWidth - scaledWidth) / 2
			const y = (targetHeight - scaledHeight) / 2

			// Create rounded rectangle path helper
			const borderRadius = 28
			const createRoundedRectPath = () => {
				ctx.beginPath()
				ctx.moveTo(x + borderRadius, y)
				ctx.arcTo(
					x + scaledWidth,
					y,
					x + scaledWidth,
					y + scaledHeight,
					borderRadius,
				)
				ctx.arcTo(
					x + scaledWidth,
					y + scaledHeight,
					x,
					y + scaledHeight,
					borderRadius,
				)
				ctx.arcTo(x, y + scaledHeight, x, y, borderRadius)
				ctx.arcTo(x, y, x + scaledWidth, y, borderRadius)
				ctx.closePath()
			}

			// First pass: Draw the shadow by filling the rounded rectangle
			ctx.save()
			ctx.shadowColor = "rgba(0, 0, 0, 0.15)"
			ctx.shadowBlur = 60
			ctx.shadowOffsetX = 0
			ctx.shadowOffsetY = 15
			createRoundedRectPath()
			ctx.fillStyle = "white"
			ctx.fill()
			ctx.restore()

			// Second pass: Clip and draw the actual image
			ctx.save()
			createRoundedRectPath()
			ctx.clip()
			ctx.drawImage(img, x, y, scaledWidth, scaledHeight)
			ctx.restore()

			// Convert to blob and create new file
			canvas.toBlob(
				(blob) => {
					if (!blob) {
						reject(new Error("Failed to create blob"))
						return
					}

					const processedFile = new File([blob], file.name, {
						type: "image/jpeg",
						lastModified: Date.now(),
					})

					resolve(processedFile)
				},
				"image/jpeg",
				0.95,
			)
		}

		img.onerror = () => reject(new Error("Failed to load image"))
		img.src = URL.createObjectURL(file)
	})
}
